export enum options {
  PAUSE = "Pause",
  ENABLE = "Enable",
  APPLY_ON_AMAZON = "Apply On Amazon",
  UNMANAGE = "Unmanage",
  APPLY_BEST_CPC = "Apply Best CPC",
  ADD_TO_PROJECT = "Add to project",
}
